import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetDeterminedAvailabilityFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetDeterminedAvailabilityFragmentFragmentDoc';

/* GraphQL */ `
  fragment GetDeterminedAvailabilityFragment on Availability {
    state
  }
`;

export type GetDeterminedAvailabilityProps = FragmentType<
  typeof GetDeterminedAvailabilityFragmentFragmentDoc
>;

export const getDeterminedAvailability = (data: GetDeterminedAvailabilityProps) => {
  const { state } = getFragmentData(GetDeterminedAvailabilityFragmentFragmentDoc, data);

  switch (state) {
    case 'AVAILABLE':
      return '1';
    case 'NOT_YET_AVAILABLE':
      return '0';
    case 'NOT_AVAILABLE':
      return '0';
    case 'UNSELECTED':
    default:
      return '2';
  }
};
